export default "__VITE_ASSET__DVaIPThv__"